import { jsx, jsxs } from "react/jsx-runtime";
import { css } from "@/styled-system/css";
import { Box, FormField, AdornedInput, FormHelp, Label, TextButton } from "@zillow/constellation-10";
import InputMask from "inputmask";
import React, { useRef, useEffect, useCallback } from "react";
import { useFormContext, useFormState } from "react-hook-form";
import { sendTextButtonInteractionEvent } from "../../utils/clickstream/MortgageCalculatorClickstream.esm.js";
import FieldTooltip from "./FieldTooltip.esm.js";
function TextField({
  label,
  leftAdornment,
  rightAdornment,
  name,
  config,
  description,
  textButtonName,
  onChange,
  onBlur,
  autoComplete,
  format,
  type,
  // This just adds a red asteriks, it does not deal with validation.
  required,
  textInputRef,
  textButtonInteractionEventInfo,
  tooltip,
  placeholder,
  disabled,
  textButtonHref,
  // This should be the argument to InputMask, there is a Typescript defintion for
  // it. For docs on usage see https://github.com/RobinHerbots/Inputmask#usage
  mask
}) {
  var _a;
  const form = useFormContext();
  const proxyFormState = useFormState();
  const error = (_a = proxyFormState == null ? void 0 : proxyFormState.errors[name]) == null ? void 0 : _a.message;
  const field = form.register(name, config);
  const inputRef = useRef(null);
  useEffect(() => {
    if (format) {
      const defaultValue = form.getValues(name);
      if (defaultValue) {
        inputRef.current.value = format(defaultValue);
      }
    }
  }, []);
  return /* @__PURE__ */ jsx(Box, { css: {
    marginBottom: "tighter"
  }, children: /* @__PURE__ */ jsx(FormField, { disabled, error: Boolean(error), label: /* @__PURE__ */ jsxs(Box, { css: {
    display: "flex",
    alignItems: "center",
    marginBottom: "tightest"
  }, children: [
    /* @__PURE__ */ jsx(Label, { children: label }),
    tooltip && /* @__PURE__ */ jsx(FieldTooltip, { ...tooltip }),
    textButtonName ? /* @__PURE__ */ jsx(Box, { css: {
      display: "flex",
      justifyContent: "space-between",
      marginLeft: "auto"
    }, children: /* @__PURE__ */ jsx(TextButton, { asChild: true, children: /* @__PURE__ */ jsx("a", { target: "_blank", rel: "nofollow noreferrer", href: textButtonHref, onClick: () => textButtonInteractionEventInfo ? sendTextButtonInteractionEvent(textButtonInteractionEventInfo) : void 0, children: textButtonName }) }) }) : ""
  ] }), required, description: /* @__PURE__ */ jsx(FormHelp, { children: error || description || /* @__PURE__ */ jsx(React.Fragment, { children: " " }) }), control: /* @__PURE__ */ jsx(AdornedInput, { css: css.raw({
    backgroundColor: "gray.50",
    boxShadowColor: "gray.300",
    _hover: {
      boxShadowColor: "border.action.hero.default"
    }
  }), startAdornment: leftAdornment && /* @__PURE__ */ jsx(AdornedInput.Adornment, { "aria-hidden": "true", children: leftAdornment }), endAdornment: rightAdornment && /* @__PURE__ */ jsx(AdornedInput.Adornment, { "aria-hidden": "true", children: rightAdornment }), input: /* @__PURE__ */ jsx(
    AdornedInput.Input,
    {
      ...field,
      type: type || "text",
      placeholder,
      onBlur: (e) => {
        field.onBlur(e);
        onBlur == null ? void 0 : onBlur(e);
      },
      onChange: (e) => {
        field.onChange(e);
        onChange == null ? void 0 : onChange(e);
      },
      onInput: format ? (e) => {
        const target = e.target;
        target.value = format(target.value);
      } : void 0,
      ref: useCallback((el) => {
        if (typeof textInputRef === "function") {
          textInputRef(el);
        } else if (typeof textInputRef === "object" && textInputRef) {
          textInputRef.current = el;
        }
        if (el && mask) {
          const masker = new InputMask(mask);
          masker.mask(el);
        }
        inputRef.current = el;
        field.ref(el);
      }, []),
      autoComplete
    }
  ) }) }) });
}
export {
  TextField as default
};
